import { createContext } from 'react';
import { TOCContextState } from '../interfaces/toc';
import { TOC_CONTEXT_INITIAL_STATE } from './constants';

export const TocContext = createContext<TOCContextState>(TOC_CONTEXT_INITIAL_STATE);
